import { StyledButtonGroup } from '@app/components/button-group/ButtonGroup';
import { StyledButton } from '@app/components/button/Button';
import { MfaCodeField } from '@app/components/form-fields/MfaCodeField';
import { Spin } from 'antd';

export type MfaFormProps = {
    onSubmit: (code: string) => void;
    onResend: () => void;
    loading?: boolean;
    resendLoading?: boolean;
};

export const MfaForm = ({ onSubmit, onResend, loading, resendLoading }: MfaFormProps) => {
    return (
        <div>
            <p>Two-Factor Authentication</p>
            <p>
                A verification code has been sent to your email address. Enter that code into the
                field below.
            </p>

            <div className="form-fields-wrapper">
                <Spin spinning={loading}>
                    <MfaCodeField onCodeFullyEntered={onSubmit} />
                </Spin>
            </div>

            <StyledButtonGroup justify="center">
                <StyledButton type="text" onClick={onResend} loading={resendLoading}>
                    Resend MFA code?
                </StyledButton>
            </StyledButtonGroup>
        </div>
    );
};
